import Vue from 'vue';

import MaskedInput from 'vue-text-mask';

Vue.use(MaskedInput);
